"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVOICE_SETTLEMENT_STATUS_TRANSITIONS = exports.PAYOUT_STATUS_TRANSITIONS = exports.PAYIN_STATUS_TRANSITIONS = void 0;
const core_payment_dto_js_1 = require("../dtos/core-payment.dto.js");
/**
 * Legal payin status transitions (HAN-613 / DR-1c).
 * Terminal: FAILED, REFUNDED. PAID → REFUNDED is reserved for DR-1g writers.
 */
exports.PAYIN_STATUS_TRANSITIONS = {
    [core_payment_dto_js_1.CoreProviderPayinStatus.INITIATED]: [
        core_payment_dto_js_1.CoreProviderPayinStatus.PENDING,
        core_payment_dto_js_1.CoreProviderPayinStatus.PAID,
        core_payment_dto_js_1.CoreProviderPayinStatus.FAILED,
    ],
    [core_payment_dto_js_1.CoreProviderPayinStatus.PENDING]: [core_payment_dto_js_1.CoreProviderPayinStatus.PAID, core_payment_dto_js_1.CoreProviderPayinStatus.FAILED],
    [core_payment_dto_js_1.CoreProviderPayinStatus.PAID]: [core_payment_dto_js_1.CoreProviderPayinStatus.REFUNDED],
    [core_payment_dto_js_1.CoreProviderPayinStatus.FAILED]: [],
    [core_payment_dto_js_1.CoreProviderPayinStatus.REFUNDED]: [],
};
/**
 * Legal payout status transitions (HAN-613 / DR-1c).
 * Terminal: COMPLETED, FAILED.
 */
exports.PAYOUT_STATUS_TRANSITIONS = {
    // REQUESTED → COMPLETED is allowed: write-through often stores CREATED as REQUESTED and
    // the next webhook/recon may observe COMPLETED without an intermediate PROCESSING write.
    [core_payment_dto_js_1.CoreProviderPayoutStatus.REQUESTED]: [
        core_payment_dto_js_1.CoreProviderPayoutStatus.PROCESSING,
        core_payment_dto_js_1.CoreProviderPayoutStatus.COMPLETED,
        core_payment_dto_js_1.CoreProviderPayoutStatus.FAILED,
    ],
    [core_payment_dto_js_1.CoreProviderPayoutStatus.PROCESSING]: [
        core_payment_dto_js_1.CoreProviderPayoutStatus.COMPLETED,
        core_payment_dto_js_1.CoreProviderPayoutStatus.FAILED,
    ],
    [core_payment_dto_js_1.CoreProviderPayoutStatus.COMPLETED]: [],
    [core_payment_dto_js_1.CoreProviderPayoutStatus.FAILED]: [],
};
/**
 * Invoice money-path settlement only: PENDING → PAID.
 * PAID → PAID is an idempotent no-op (same-status short-circuit in the guard).
 * DRAFT / CANCELLED / CLOSED stay with invoice-edit; PAID → REFUNDED is DR-1g.
 */
exports.INVOICE_SETTLEMENT_STATUS_TRANSITIONS = {
    pending: ["paid"],
    paid: ["paid"],
};
